import { storableError } from '../util/errors';
import { fetchCurrentUser } from './user.duck';
import { brevoSendSms, shortenLink } from '../util/api';
import { renderSms } from '../util/sms';

const MARKETPLACE_NAME = process.env.REACT_APP_MARKETPLACE_NAME;
const MARKETPLACE_ROOT_URL = process.env.REACT_APP_MARKETPLACE_ROOT_URL;

// ================ Action types ================ //

export const VERIFICATION_REQUEST = 'app/emailVerification/VERIFICATION_REQUEST';
export const VERIFICATION_SUCCESS = 'app/emailVerification/VERIFICATION_SUCCESS';
export const VERIFICATION_ERROR = 'app/emailVerification/VERIFICATION_ERROR';

// ================ Reducer ================ //

const initialState = {
  isVerified: false,

  // verification
  verificationError: null,
  verificationInProgress: false,
};

export default function reducer(state = initialState, action = {}) {
  const { type, payload } = action;
  switch (type) {
    case VERIFICATION_REQUEST:
      return {
        ...state,
        verificationInProgress: true,
        verificationError: null,
      };
    case VERIFICATION_SUCCESS:
      return { ...state, verificationInProgress: false, isVerified: true };
    case VERIFICATION_ERROR:
      return { ...state, verificationInProgress: false, verificationError: payload };
    default:
      return state;
  }
}

// ================ Selectors ================ //

export const verificationInProgress = state => {
  return state.emailVerification.verificationInProgress;
};

// ================ Action creators ================ //

export const verificationRequest = () => ({ type: VERIFICATION_REQUEST });
export const verificationSuccess = () => ({ type: VERIFICATION_SUCCESS });
export const verificationError = error => ({
  type: VERIFICATION_ERROR,
  payload: error,
  error: true,
});

// ================ Thunks ================ //

export const verify = (verificationToken, phoneNumber, firstName, isNewEmail, intl) => (
  dispatch,
  getState,
  sdk
) => {
  if (verificationInProgress(getState())) {
    return Promise.reject(new Error('Email verification already in progress'));
  }
  dispatch(verificationRequest());

  // Note that the thunk does not reject when the verification fails, it
  // just dispatches the login error action.
  return sdk.currentUser
    .verifyEmail({ verificationToken })
    .then(() => dispatch(verificationSuccess()))
    .then(() => dispatch(fetchCurrentUser({ enforce: true })))
    .then(res => {
      const url = isNewEmail ? MARKETPLACE_ROOT_URL + '/verify-email' : MARKETPLACE_ROOT_URL;
      return shortenLink({ url: url }).then(({ shortUrl }) => ({
        res,
        shortenedLink: shortUrl,
      }));
    })
    .then(({ res, shortenedLink }) => {
      if (!phoneNumber) {
        return res;
      }

      const smsParams = {
        firstName: firstName,
        marketplaceName: MARKETPLACE_NAME,
        link: shortenedLink,
      };
      const smsTemplateKey = isNewEmail ? 'verify_changed_email_address' : 'user_joined';
      const sms = renderSms(smsTemplateKey, smsParams, intl);
      brevoSendSms({
        message: sms,
        phone: phoneNumber,
      });
      return res;
    })
    .catch(e => dispatch(verificationError(storableError(e))));
};
